export default "/img/MG.7835c98ad723ec542039a2515747b4f4.png";